import axios from 'axios'
import {Role, RolesQueryResponse} from './_models'
import {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_API_URL_NEW

export const ROLES_URL = `${API_URL}/role`

export function getRoles(query: string = ''): Promise<RolesQueryResponse> {
  return axios
    .get(`${ROLES_URL}?${query}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('auth-token')}`,
      },
    })
    .then((response: AxiosResponse<RolesQueryResponse>) => response.data)
}

export function getRole(id: number) {
  return axios.get<Role>(`${ROLES_URL}/${id}`)
}

export function createRole(role: { name: string; status: number; permissions: number[] }): Promise<Role> {
  return axios.post<{ responseStatus: number; responseData: Role; message: string }>(`${ROLES_URL}`, role, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('auth-token')}`,
    },
  }).then((response : any) => {
    if (response.data.responseStatus === 200 && response.data.responseData) {
      return response.data.responseData;
    }
    throw new Error(response.data.responseMessage || 'Failed to create role');
  });
}

export function updateRole(id: number, role: { name: string; status: number; permissions: number[] }): Promise<Role> {
  return axios.put<{ responseStatus: number; responseData: Role; message: string }>(`${ROLES_URL}/${id}`, role, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('auth-token')}`,
    },
  }).then(response => {
    if (response.data.responseStatus === 200 && response.data.responseData) {
      return response.data.responseData;
    }
    throw new Error(response.data.message || 'Failed to update role');
  });
}

export function updateRoleStatus(id: number, data: { status: boolean }): Promise<any> {
  return axios.put<{ responseStatus: number; responseMessage: string }>(`${ROLES_URL}/status/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('auth-token')}`,
    },
  }).then(response => {
    if (response.data.responseStatus === 200) {
      return response.data;
    }
    throw new Error(response.data.responseMessage || 'Failed to update role status');
  });
}

export function deleteRole(id: number) {
  return axios.delete(`${ROLES_URL}/${id}`)
}

export function deleteSelectedRoles(selectedIds: number[]) {
  const requests = selectedIds.map((id) => axios.delete(`${ROLES_URL}/${id}`))
  return axios.all(requests)
}

export function getRoleById(id: number) {
  return axios.get(`${ROLES_URL}/${id}`).then((response) => response.data)
} 